import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TOOLTIP_DELAY } from "../../../../common/Constants";
import { CellTmpl, DEFAULT_OPTIONS_PAYLOAD, reactFormatter } from "../../../../common/Table";
import { useDeleteDepartment, useGetCompanies, useGetDepartments, useGetVerticals } from "../../../../../backend/masters";
import { DEFAULT_OPTION } from "../../../../common/TableFilter";
import DepartmentDetails from "./DepartmentDetails";
import { useExportDepartments } from "../../../../../backend/exports";
import BaseList from "../../../../common/BaseList";
import AddEditDepartment from "./AddEditDepartment";
import { DepartmentSchema } from "../../../../../models/department";

const DEPARTMENTS_DEFAULT_PAYLOAD = {
    sorts: ['updated_at desc'],
    includes: {
        vertical: "company"
    },
    include: {
      vertical: {
        only: ['id','name'],
        include: {
          company: {
            only: ['id','name']
          }
        }
      }
    }
  }

function ManageDepartments() {
    const [t] = useState(new Date().getTime());
    const [breadcrumb] = useState([
        { id: 'home', label: 'Home', path: '/' },
        { id: 'companies', label: 'Companies', path: '/companies/list' },
        { id: 'departments', label: 'Departments' },
    ]);
    const [department, setDepartment] = useState<any>(null);
    const [company, setCompany] = useState<any>(DEFAULT_OPTION);
    const [vertical, setVertical] = useState<any>(DEFAULT_OPTION);
    const { companies, isFetching: fetchingCompanies } = useGetCompanies({ ...DEFAULT_OPTIONS_PAYLOAD, filters: [{ columnName: 'isParent', value: 'true' }], t });
    const { verticals } = useGetVerticals({
        ...DEFAULT_OPTIONS_PAYLOAD,
        filters: Boolean(company) && company.value !== DEFAULT_OPTION.value ? [{ columnName: 'company_id', value: company.value }] : [], t
    });
    
    const filterConfig = [
        {
            label: 'Company',
            name: 'company_id_eq',
            options: (companies || []).map((x: any) => {
                return { value: x.id, label: x.name };
            }),
            value: company
        },
        {
            label: 'Vertical',
            name: 'vertical_id_eq',
            options: (verticals || []).map((x: any) => {
                return { value: x.id, label: x.name };
            }),
            value: vertical
        }
    ]

    function CompanyTmpl({ cell }: any) {
        const row = cell.getData();
        const vertical = (row || {}).vertical || {};
        const value = ((vertical || {}).company || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    function VerticalTmpl({ cell }: any) {
        const row = cell.getData();
        const value = ((row || {}).vertical || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }

    const columns = [
        { title: "Company", field: "company_id", formatter: reactFormatter(<CompanyTmpl />) },
        { title: "Vertical", field: "vertical_id", formatter: reactFormatter(<VerticalTmpl />) },
        { title: "Department Code", field: "short_code", formatter: reactFormatter(<CellTmpl />) },
        { title: "Department Name", field: "name", formatter: reactFormatter(<CellTmpl />) },
        { title: "Description", field: "description", formatter: reactFormatter(<CellTmpl />), widthGrow: 2 }
    ]

    return (
        <BaseList
            fetchData={useGetDepartments}
            exportData={useExportDepartments}
            deleteData={useDeleteDepartment}
            nameAttribute={'name'}
            columns={columns}
            DetailView={DepartmentDetails}
            FormView={AddEditDepartment}
            modelSchema={DepartmentSchema}
            initialSort={['name asc']}
            breadcrumb={breadcrumb}
            initialPayload={DEPARTMENTS_DEFAULT_PAYLOAD}
            filterConfig={filterConfig}
            title="Companies - Departments"
        />
    )
}

export default ManageDepartments;
